import {useLocation} from "react-router-dom";
import SchoolDiagnose from "@/components/SchoolDiagnose";
import Layout from "@/components/Layout";

const Home = () => {
    const location = useLocation();
    if(location.pathname === '/schoolDiagnose' ) {
        return (
           <SchoolDiagnose></SchoolDiagnose>
        );
    }
    return (
        <Layout></Layout>
    );
};
export default Home;
